const { useEffect } = require("react");

const BusinessAssociateAgreement = () => {
  const baaLink = "https://storage.googleapis.com/noki_public/Noki_%20BAA.pdf";

  useEffect(() => {
    try {
      window.location.href = baaLink;
    } catch (error) {
      console.error("Redirection failed:", error);
    }
  }, []);

  return null;
};

export default BusinessAssociateAgreement;
